import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import MainLayout from './components/MainLayout';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<MainLayout />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js